import { useLocation } from 'react-router-dom';
import { sheetsAddonFaqData } from '../Common/SheetsAddonFaqData';

function SheetsAddonFAQ(){

    const isShowConsole = process.env.NODE_ENV === 'development';

    const location = useLocation();
    isShowConsole && console.log("Current Path:", location.pathname);

    const faqEle = sheetsAddonFaqData.map((ele, idx) => {
        return(
            <div className='faqEle' key={idx}>
                <h3 className='question'>{idx+1}. {ele.question}</h3>
                <p className='answer'>{ele.answer}</p>
            </div>
        )
    });

    return(
        <div id='sheetsAddonFaq' className='faqContainer'>
            <div className='faqWrapper'>
                <div className='contentDiv'>
                    <div className='containerDiv'>
                        <div className='title'>Frequently Asked Questions</div>
                        <div className='contentBox'>
                            <div className='content'>
                                {faqEle}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SheetsAddonFAQ;